// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-switcher label {
  display: block;
  float: left !important;
  cursor: pointer;
  position: relative;
  width: 36px;
  flex: 0 0 36px;
  height: 18px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  -moz-border-radius: 50rem;
  -webkit-border-radius: 50rem;
  border-radius: 50rem;
}
.ultimate-security-switcher label span {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background-color: #fff;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -moz-transition: left 0.15s ease-out;
  -o-transition: left 0.15s ease-out;
  -webkit-transition: left 0.15s ease-out;
  transition: left 0.15s ease-out;
}
.ultimate-security-switcher label input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.ultimate-security-switcher label input:checked ~ em {
  background-color: var(--plus-color-purple-40);
}
.ultimate-security-switcher label input:checked ~ em::before {
  opacity: 0;
}
.ultimate-security-switcher label input:checked ~ em::after {
  opacity: 1;
}
.ultimate-security-switcher label input:checked ~ span {
  left: 20px;
}
.ultimate-security-switcher label em {
  -moz-border-radius: 50rem;
  -webkit-border-radius: 50rem;
  border-radius: 50rem;
  font-size: 11px;
  line-height: 26px;
  font-weight: 500;
  font-style: normal;
  text-transform: uppercase;
  color: #fff;
  position: relative;
  display: block;
  height: inherit;
  background-color: #b2b2b2;
  -moz-transition: background 0.15s ease-out;
  -o-transition: background 0.15s ease-out;
  -webkit-transition: background 0.15s ease-out;
  transition: background 0.15s ease-out;
}
.ultimate-security-switcher label em::before {
  position: absolute;
  -moz-transition: opacity 0.15s ease-out;
  -o-transition: opacity 0.15s ease-out;
  -webkit-transition: opacity 0.15s ease-out;
  transition: opacity 0.15s ease-out;
  right: 14px;
}
.ultimate-security-switcher label em::after {
  position: absolute;
  -moz-transition: opacity 0.15s ease-out;
  -o-transition: opacity 0.15s ease-out;
  -webkit-transition: opacity 0.15s ease-out;
  transition: opacity 0.15s ease-out;
  left: 14px;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Switch/Switch.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAAR;AACQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;EACA,uCAAA;EACA,+BAAA;AACZ;AACQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACZ;AAEgB;EACI,6CAAA;AAApB;AACoB;EACA,UAAA;AACpB;AACoB;EACA,UAAA;AACpB;AAEgB;EACI,UAAA;AAApB;AAKQ;EACI,yBAAA;EACA,4BAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,6CAAA;EACA,qCAAA;AAHZ;AAIY;EACA,kBAAA;EACA,uCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EAEA,WAAA;AAHZ;AAKY;EACA,kBAAA;EACA,uCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EAEA,UAAA;EACA,UAAA;AAJZ","sourcesContent":[".ultimate-security-switcher {\n    label {\n        display: block;\n        float: left !important;\n        cursor: pointer;\n        position: relative;\n        width: 36px;\n        flex: 0 0 36px;\n        height: 18px;\n        padding: 0;\n        margin: 0;\n        overflow: hidden;\n        -moz-border-radius: 50rem;\n        -webkit-border-radius: 50rem;\n        border-radius: 50rem;\n        span {\n            position: absolute;\n            top: 2px;\n            left: 2px;\n            width: 14px;\n            height: 14px;\n            background-color: #fff;\n            -moz-border-radius: 50%;\n            -webkit-border-radius: 50%;\n            border-radius: 50%;\n            -moz-transition: left 0.15s ease-out;\n            -o-transition: left 0.15s ease-out;\n            -webkit-transition: left 0.15s ease-out;\n            transition: left 0.15s ease-out;\n        }\n        input {\n            position: absolute;\n            top: 0;\n            left: 0;\n            opacity: 0;\n            &:checked {\n                ~ {\n                em {\n                    background-color:var(--plus-color-purple-40);\n                    &::before {\n                    opacity: 0;\n                    }\n                    &::after {\n                    opacity: 1;\n                    }\n                }\n                span {\n                    left: 20px;\n                }\n                }\n            }\n        }\n        em {\n            -moz-border-radius: 50rem;\n            -webkit-border-radius: 50rem;\n            border-radius: 50rem;\n            font-size: 11px;\n            line-height: 26px;\n            font-weight: 500;\n            font-style: normal;\n            text-transform: uppercase;\n            color: #fff;\n            position: relative;\n            display: block;\n            height: inherit;\n            background-color: #b2b2b2;\n            -moz-transition: background 0.15s ease-out;\n            -o-transition: background 0.15s ease-out;\n            -webkit-transition: background 0.15s ease-out;\n            transition: background 0.15s ease-out;\n            &::before {\n            position: absolute;\n            -moz-transition: opacity 0.15s ease-out;\n            -o-transition: opacity 0.15s ease-out;\n            -webkit-transition: opacity 0.15s ease-out;\n            transition: opacity 0.15s ease-out;\n            // content: attr(data-off);\n            right: 14px;\n            }\n            &::after {\n            position: absolute;\n            -moz-transition: opacity 0.15s ease-out;\n            -o-transition: opacity 0.15s ease-out;\n            -webkit-transition: opacity 0.15s ease-out;\n            transition: opacity 0.15s ease-out;\n            // content: attr(data-on);\n            left: 14px;\n            opacity: 0;\n            }\n        }\n    }      \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
